/* eslint-disable no-unused-vars */

import React, { useState, useEffect, useMemo } from 'react';
import { Box, Text } from '@chakra-ui/react';

import UserAuth from 'components/User/UserAuth';
import CollectionSelector from 'components/Segments/CollectionSelector';
import SortableTable from 'components/Segments/SortableTable';
import SimpleCloud from './SimpleCloud';
import useSearchResults, { ResultLink } from 'hooks/useSearchResults';

import _ from 'lodash';

const PollAutocomplete = () => {
  const kind = 'options';
  const [cloud, setCloud] = useState([]);
  const x = {
    matches: [
      {
        data: {
          description:
            "It's impossible to compensate for the damage that has been done, but we must start.",
          label: 'Reparations for Slavery and Genocide'
        },
        _id: 'Options/2c3dd8f7-a767-4948-8977-3ed33fe765d9'
      },
      {
        _id: 'Options/5050243a-6443-497a-9fad-ddba41ec05ea',
        data: {
          description: '',
          label: 'Protect and Regenerate Biodiversity'
        }
      },
      {
        data: {
          description:
            'enforcement of deepest punishments and paybacks in the face of crimes against Gaia',
          label: 'Severe Penalties and Reparations for Ecocide'
        },
        _id: 'Options/2783de6e-8b9a-407f-abb8-c817c8265316'
      },
      {
        _id: 'Options/9675e277-eddb-4e11-8335-7d4264af4637',
        data: {
          description: 'Nora Bateson often refers to this and I believe there is a lot there!',
          label: 'food & shelter for mothers and their babies'
        }
      },
      {
        _id: 'Options/4e4d1ba3-3cc0-4240-aaa7-15ce4d39c1aa',
        data: {
          description: 'Return what was stolen.',
          label: '#LandBack to Indigenous People'
        }
      },
      {
        _id: 'Options/4d743a0f-b41b-4c4e-a526-fcad38424e64',
        data: {
          label: 'Protect and Revitalize the Oceans',
          description: ''
        }
      }
    ]
  };

  useEffect(() => {
    if (cloud.length == 0) {
      let empty = [];
      x.matches.forEach((one, i) => {
        empty.push({ count: i, value: one.data.label, ...one.data });
      });
      setCloud(empty);
    }
  }, [cloud.length, x.matches]);
  const {
    defaultColumnProperties,
    map_column_title,
    map_column_sx,
    get_columns
  } = useSearchResults(kind);

  const [myChoices, setMyChoices] = useState([]);

  const cols = useMemo(() => {
    if (myChoices?.length) {
      return get_columns(kind).map(key => {
        return {
          ...defaultColumnProperties,
          key: key,
          name: map_column_title(_.capitalize(key), kind),
          sx: map_column_sx(key, kind)
        };
      });
    }
    return [];
  }, [defaultColumnProperties, get_columns, myChoices, map_column_sx, map_column_title]);

  const onSelectOption = data => {
    console.log('Selected', data);
    data.title = data.label || data.fullname;
    let current = [...myChoices];
    const matched = current.filter(one => one.title == data.title).length > 0;
    console.log('m', matched);
    if (!matched) {
      current.push(data);
      setMyChoices(current);
    }
  };
  const onWordClick = e => {
    console.log('clicked ', e);
  };
  return (
    <Box>
      <CollectionSelector
        onSelect={onSelectOption}
        inputPlaceholder={'Name of ecoregion...'}
        label={'What matters to me?'}
        searchParams={{
          queryName: 'aqlOptionsAutocomplete',
          question_id: 'Questions/6c21ac0a-cee5-486a-bd25-97945de6079c'
        }}
      />
      <SimpleCloud data={cloud} onClick={onWordClick} />
      {myChoices.length > 0 && (
        <SortableTable
          columns={cols}
          rows={myChoices}
          headRowSx={{ backgroundColor: 'cyan.900' }}
          resultsCellSx={{ padding: '4px 4px 0 0', a: { pt: 0 } }}
        />
      )}
      {myChoices.length > 0 && (
        <Box>
          <Text>Community Results</Text>
          <Text>Analytics</Text>
          <Text>Matchmaking</Text>
        </Box>
      )}
      <UserAuth unauthorized='signin'></UserAuth>
    </Box>
  );
};

export default PollAutocomplete;
